<template>
  <div class="account-right fixed-mp-cls">
    <div class="account-breadcrumb d-none d-sm-block">
      <ul class="breadcrumb-innerpage">
        <li>
          <router-link :to="{ name: 'home' }"
            >{{ _T('Home')
            }}<img src="/images/svg/global/arrow-right-r.svg" alt=""
          /></router-link>
        </li>
        <li>{{ _T('Notifications') }}</li>
      </ul>
    </div>
    <div class="account-card">
      <div class="account-header">
        <h4>
          {{ _T('Notification') }}
          <!-- <span class="mark-cls">{{ _T('Mark all as read') }}</span> -->
        </h4>
      </div>
      <!-- <div class="notification-section">
        <div class="title-panel">
          <h6>{{ _T('new') }}</h6>
        </div>
        <ul class="notifications">
         <NotificationItem :is-read="false" />
        </ul>
      </div> -->
      <h5 class="ml-4 p-3 nothing-found">{{ _T('Coming soon') }}...</h5>
      <!-- <div class="notification-section">
        <div class="title-panel">
          <h6>{{ _T('old') }}</h6>
        </div>
        <ul class="notifications">
          <NotificationItem :is-read="false" />
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
// import NotificationItem from '@/components/Collections/Notification/NotificationItem'
import { mapGetters } from 'vuex'
export default {
  name: 'Notifications',
  components: {
    // NotificationItem,
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .account-menu {
    .account-breadcrumb {
      ul {
        padding-left: unset;
        padding-right: 0;
        text-align: right;
      }
    }
  }
}
.account-card {
  .nothing-found {
    font-weight: bold;
  }
}
.account-header {
  border-bottom: $px1 solid $light-border;
  padding: $px16 $px50;

  h4 {
    font-weight: 600;
    margin-bottom: 0;

    .mark-cls {
      font-size: $px14;
      line-height: $px22;
      color: $color-primary;
      float: right;
    }
  }
}
.notification-section {
  .title-panel {
    background: rgba(var(--color-light-font-source), 0.3);
    padding: $px3 $px30;

    h6 {
      text-transform: uppercase;
      margin-bottom: 0;
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
    }
  }

  .notifications {
    /deep/ li {
      display: flex;
      align-items: center;
      background: $light-border;
      padding: $px20 $px60;

      .notification-icon {
        background: $white;
        border-radius: $px15;
        width: $px52;
        height: $px52;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .details {
        margin-left: $px30;
        max-width: 78%;

        h6 {
          font-style: normal;
          font-weight: 600;
          font-size: $px14;
          line-height: $px22;
          letter-spacing: 0.005em;
          color: $font-color;
          margin-bottom: 0;

          span {
            font-weight: 600;
            font-size: $px14;
            line-height: $px22;
            margin-left: $px42;
            letter-spacing: 0.005em;
            color: $light-font;
          }
        }

        p {
          font-weight: normal;
          font-size: $px12;
          line-height: $px18;
          color: $font-color;
          margin-bottom: 0;
        }
      }

      .settings {
        opacity: 0;
        visibility: hidden;
        margin-left: auto;

        .dropdown-menu {
          padding: $px14 $px20;
          top: 120%;
          right: 0;
          left: unset;
          border: none;
          background: $white;
          box-shadow: 0px 3.48882px 8.72204px rgba($black, 0.1);
          border-radius: $px4;

          .dropdown-item {
            font-weight: 600;
            font-size: $px14;
            line-height: $px22;
            letter-spacing: 0.005em;
            padding: 0;
            color: $font-color;
            cursor: pointer;
            background-color: $transparent;

            &:hover {
              color: $color-primary;
            }

            &:active {
              background-color: $white;
            }

            + .dropdown-item {
              padding-top: $px12;
              margin-top: $px12;
              border-top: 0.5px solid $light-border;
            }
          }

          &:after {
            content: '';
            position: absolute;
            top: -$px10;
            width: $px19;
            height: $px17;
            right: $px4;
          }
        }
      }

      &.read {
        background: $white;
      }

      &:hover {
        background: $grey-1;

        .settings {
          opacity: 1;
          visibility: visible;
        }
      }

      + li {
        border-top: $px1 solid $light-border;
      }
    }
  }
}
.account-breadcrumb {
  ul {
    li {
      line-height: $px17;
      letter-spacing: 0.005em;
      a {
        font-weight: 600;
      }
      img {
        margin-left: $px12;
        margin-right: $px7;
      }
    }
  }
  .breadcrumb-innerpage {
    li {
      font-weight: 600;
    }
  }
}
.account-menu {
  padding-top: $px40;
  .menu-left {
    margin-bottom: $px90;
    .menu-title {
      h4 {
        margin-bottom: calc(
          #{$px30} + (68 - 30) * ((100vw - #{$px320}) / (1920 - 320))
        );
        font-size: calc(
          #{$px16} + (20 - 16) * ((100vw - #{$px320}) / (1920 - 320))
        );
        line-height: $px24;
        color: $font-color;
        font-weight: 600;
        span {
          display: none;
        }
      }
    }
    ul {
      li {
        display: block;
        &.active {
          a {
            svg {
              path {
                fill: $primary-color !important;
              }
            }
            h4 {
              color: $primary-color;
            }
          }
        }
        a {
          svg {
            vertical-align: bottom;
          }
          h4 {
            display: inline-block;
            margin-bottom: 0;
            padding-left: $px6;
            color: $font-color;
            position: relative;
            .dot-notify {
              width: $px6;
              height: $px6;
              background-color: $primary-color;
              border-radius: 100%;
              position: absolute;
              top: 0;
              right: -$px12;
            }
          }
        }
        + li {
          margin-top: calc(
            #{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
      }
    }
  }
  .account-right {
    .account-breadcrumb {
      ul {
        li {
          line-height: $px17;
          letter-spacing: 0.005em;
          a {
            font-weight: 600;
          }
          img {
            margin-left: $px12;
            margin-right: $px7;
          }
        }
      }
      .breadcrumb-innerpage {
        li {
          font-weight: 600;
        }
      }
    }
    .account-card {
      box-shadow: 0px $px4 $px34 rgba($black, 0.07);
      margin: $px18 0 $px30;
      border-radius: $px10;
      .account-body {
        &.profile-media {
          .media {
            padding: calc(
                #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
              )
              calc(#{$px20} + (45 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
            align-items: center;
            .btn {
              padding: 8px
                calc(
                  #{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320))
                );
            }
            + .media {
              border-top: $px1 solid $light-border;
            }
            .profile-user {
              img {
                width: $px40;
                height: $px40;
                border-radius: 100%;
              }
            }
            .media-body {
              margin-left: $px20;
              h6 {
                margin-bottom: $px5;
                line-height: $px14;
                letter-spacing: 0.005em;
                color: rgba(var(--color-font-color-source), 0.44);
                font-weight: 500;
              }
              h4 {
                margin-bottom: 0;
                line-height: $px18;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
}
</style>
